import { render, staticRenderFns } from "./SearchQuery.vue?vue&type=template&id=36af8454&"
import script from "./SearchQuery.vue?vue&type=script&lang=ts&"
export * from "./SearchQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports